export default "__VITE_ASSET__Bem6V1Hq__"